import { render } from "./JDetail.vue?vue&type=template&id=057e8b98&scoped=true"
import script from "./JDetail.vue?vue&type=script&lang=js"
export * from "./JDetail.vue?vue&type=script&lang=js"

import "./JDetail.vue?vue&type=style&index=0&id=057e8b98&lang=scss&scoped=true"
import "./JDetail.vue?vue&type=style&index=1&id=057e8b98&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057e8b98"]])

export default __exports__